export enum BankAccountType {
    checking = 'checking',
    saving = 'saving'
}
